module.exports = __webpack_public_path__ + "613fa63229c39929569f90600e47903f.svg";